import { EditCallLogSettingsComponent } from './../edit-call-log-settings/edit-call-log-settings.component';
import { SettingsService } from './../../_services/settings.service';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { LocalStorageService } from 'src/app/_services/local-storage.service';


@Component({
  selector: 'app-call-log-settings',
  templateUrl: './call-log-settings.component.html',
  styleUrls: ['./call-log-settings.component.scss']
})
export class CallLogSettingsComponent implements OnInit {

  outcomelistopen: Boolean = false;
  outcomeslist: Array<any>;

  @ViewChild('delete') delete: TemplateRef<any>;
  @ViewChild('redo') redo: TemplateRef<any>;

  errorMessage: string = null;
  successMessage: string = null;
  delete_confirmaton: string = null;
  positiveOutcome: any
  negativeOutcome: any
  neutralOutcome: any
  positiveInactiveOutcome: any
  negativeInactiveOutcome: any
  neutralInactiveOutcome: any
  outcomedata: any
  redoutcome: any
  // deleted_item:any = []
  newPositiveDeleteItem: any
  
  constructor(private modalService: NgbModal ,private settingservice : SettingsService,
    private _localstorageservice : LocalStorageService) { }

  ngOnInit() {
    this.getOutcomesList(this._localstorageservice.getItem('usernumber'))
  }


  dismiss() {
    this.modalService.dismissAll();
  }

  toastmessage(message ,type)
  {
    if(type == 'success'){
      this.successMessage = message;
      setTimeout(() => {this.successMessage = ''},5000);
    }else if (type == 'error')
    this.errorMessage = message;
    setTimeout(() => {this.errorMessage = ''},5000);
  }
  
  getOutcomesList(outcomename) {
    this.outcomelistopen = true;
    this.settingservice.getOutcomeList(outcomename).subscribe(
      (res: any) => {
        if (res && res.message) {
          this.outcomeslist = _.sortBy(res.message,function(call){
            return call.outcometext.toLowerCase()})
          this.positiveOutcome = this.outcomeslist.filter((x) => {
            return x.outcometype == 'Positive' && x.isactive == 1
          });
          this.negativeOutcome = this.outcomeslist.filter((x) => {
            return x.outcometype == 'Negative' && x.isactive == 1
          });
          this.neutralOutcome = this.outcomeslist.filter((x) => {
            return x.outcometype == 'Neutral' && x.isactive == 1
          });
          this.positiveInactiveOutcome = this.outcomeslist.filter((x) => {
            return x.outcometype == 'Positive' && x.isactive == 0
          });
          this.negativeInactiveOutcome = this.outcomeslist.filter((x) => {
            return x.outcometype == 'Negative' && x.isactive == 0
          });
          this.neutralInactiveOutcome = this.outcomeslist.filter((x) => {
            return x.outcometype == 'Neutral' && x.isactive == 0
          });
        }
      }
    );
  }


  openDeleteConfirmationModal(outcome) {
    this.outcomedata = outcome;
    this.delete_confirmaton = 'Are you sure want to delete Outcome'
    const modalRef = this.modalService.open(this.delete, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }
  openRedoConfirmationModal(outcome) {
    this.redoutcome = outcome;
    this.delete_confirmaton = 'Are you sure want to Restore Outcome'
    const modalRef = this.modalService.open(this.redo, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  openCalllogModal() {
    const modalRef = this.modalService.open(EditCallLogSettingsComponent, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      if(receivedEntry == 'added'){
       this.toastmessage('Call log outcome added successfully' , 'success')
       this.getOutcomesList(this._localstorageservice.getItem('usernumber'))
     }else if(receivedEntry == 'error'){
       this.toastmessage('Something went wrong, Please try again in a minute' , 'error')
     }
   })
  }
  
  editCallLogModal(outcome) {
    const modalRef = this.modalService.open(EditCallLogSettingsComponent, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.editoutcome = outcome
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
    if(receivedEntry == 'modify'){
       this.toastmessage('Call log outcome Edited successfully' , 'success')
       this.getOutcomesList(this._localstorageservice.getItem('usernumber'))
     }else if(receivedEntry == 'error'){
      this.toastmessage('Something went wrong' , 'error')
    }
   })
  }

  deleteCallLogOutcome() {
    let data = {
      "editDetails": {
        isactive: 0,
        "outcometype": "'" + this.outcomedata.outcometype + "'",
        "updatedby": this._localstorageservice.getItem('userid')
      },
      "outcomeid": this.outcomedata.outcomeid
    }

    this.settingservice.editOutcome(data).subscribe((res: any) => {
      if (res.status == 'success') {
        if (this.outcomedata.outcometype == "Positive") {
          this.positiveOutcome = _.pull(this.positiveOutcome, _.find(this.positiveOutcome, this.outcomedata));
          this.positiveInactiveOutcome.push({ 'outcomeid': this.outcomedata.outcomeid, 'outcometype': this.outcomedata.outcometype, 'outcometext': this.outcomedata.outcometext, isactive: 0 })
        } 
        else if (this.outcomedata.outcometype == "Negative") {          
          this.negativeOutcome = _.pull(this.negativeOutcome, _.find(this.negativeOutcome, this.outcomedata));
          this.negativeInactiveOutcome.push({ 'outcomeid': this.outcomedata.outcomeid, 'outcometype': this.outcomedata.outcometype, 'outcometext': this.outcomedata.outcometext, isactive: 0 })
        }
         else if (this.outcomedata.outcometype == "Neutral") {
          this.neutralOutcome = _.pull(this.neutralOutcome, _.find(this.neutralOutcome, this.outcomedata));
          this.neutralInactiveOutcome.push({ 'outcomeid': this.outcomedata.outcomeid, 'outcometype': this.outcomedata.outcometype, 'outcometext': this.outcomedata.outcometext, isactive: 0 })
        }
        this.modalService.dismissAll();
        this.toastmessage('Call log outcome deleted successfully' , 'success')
        this.getOutcomesList(this._localstorageservice.getItem('usernumber'))
      }else {
        this.modalService.dismissAll();
        this.toastmessage('Something went wrong' , 'error')
      }
    })
  }

  redoCallLogOutcome() {
    let data = {
      "editDetails": {
        isactive: 1,
        "outcometype": "'" + this.redoutcome.outcometype + "'",
        "updatedby": this._localstorageservice.getItem('userid')
      },
      "outcomeid": this.redoutcome.outcomeid
    }
    this.settingservice.editOutcome(data).subscribe((res: any) => {
      if (res.status == 'success') {
        if (this.redoutcome.outcometype == "Positive") {
          this.positiveInactiveOutcome = _.pull(this.positiveInactiveOutcome, _.find(this.positiveInactiveOutcome, this.redoutcome));
          this.positiveOutcome.push({ 'outcomeid': this.redoutcome.outcomeid, 'outcometype': this.redoutcome.outcometype, 'outcometext': this.redoutcome.outcometext, isactive: 1 })
        } 
        else if (this.redoutcome.outcometype == "Negative") {
          this.negativeInactiveOutcome = _.pull(this.negativeInactiveOutcome, _.find(this.negativeInactiveOutcome, this.redoutcome));
          this.negativeOutcome.push({ 'outcomeid': this.redoutcome.outcomeid, 'outcometype': this.redoutcome.outcometype, 'outcometext': this.redoutcome.outcometext, isactive: 1 })
        }
         else if (this.redoutcome.outcometype == "Neutral") {
          this.neutralInactiveOutcome = _.pull(this.neutralInactiveOutcome, _.find(this.neutralInactiveOutcome, this.redoutcome));
          this.neutralOutcome.push({ 'outcomeid': this.redoutcome.outcomeid, 'outcometype': this.redoutcome.outcometype, 'outcometext': this.redoutcome.outcometext, isactive: 1 })
        }
        this.modalService.dismissAll();
        this.toastmessage('Call log outcome restore successfully' , 'success')
        this.getOutcomesList(this._localstorageservice.getItem('usernumber'))
      }else {
        this.modalService.dismissAll();
        this.toastmessage('Something went wrong' , 'error')
      }
    })
  }

}
